import {parseISO} from "date-fns/parseISO";
import {format} from "date-fns/format";
import { formatInTimeZone } from "date-fns-tz";

import {assertObject, assertString} from "core/validation";
import {
    startOfMonth,
    endOfMonth,
    startOfQuarter,
    endOfQuarter,
    startOfYear,
    endOfYear,
    subMonths,
    subQuarters,
    subYears, subDays
} from "date-fns";
export const DATE_FORMAT_SHORT = "yyyy-MM-dd";
export const DATE_FORMAT_ZONE_TIME_LONG= "yyyy-MM-dd'T'HH:mm:ss.SSSxxx";
export const DATE_FORMAT_HOUR_AM_PM = "hh:mm a";
export const DATE_FORMAT_HOUR = "hh:mm";
export const DATE_FORMAT_TEXT_INPUT = "MM/dd/yyyy";
export const DATE_FORMAT_SHORT_YEAR = "MM/dd/yy";
export const DATE_FORMAT_ONLY_YEAR  = "yyyy";
export const DATE_FORMAT_FULL_INPUT = "MM/dd/yyyy h:mm a";
export const DATE_FORMAT_FULL_INPUT_ZONE =  "MM/dd/yyyy h:mm a zzz";
export function dateToString(date) {
    if(!assertObject(date)) {
        return null;
    }
    const _date = date instanceof Date ? date : parseISO(date);
    return format(_date, DATE_FORMAT_SHORT);
}
export function formatDate(date, dateFormat = DATE_FORMAT_SHORT, addTimezone = false) {
    if(!assertObject(date)) {
        return null;
    }
    const _date = date instanceof Date ? date : parseISO(date);
    if(addTimezone) {
        return formatInTimeZone(date, "America/Los_Angeles", dateFormat); // 2014-10-25 06:46:20 EST
    }
    return format(_date, dateFormat);
}
export function stringToDate(stringDate) {
    if (!assertString(stringDate)) {
        return null;
    }
    return parseISO(stringDate);
}

export function reportIntervalToDate({dateFrom, dateTo, interval}) {
    switch (interval) {
    case INTERVALS.CURRENT_MONTH.value: {
        const today = new Date();
        const from = startOfMonth(today);
        const to = endOfMonth(today);
        return {from, to};
    }
    case INTERVALS.CURRENT_QUARTER.value: {
        const today = new Date();
        const from = startOfQuarter(today);
        const to = endOfQuarter(today);
        return {from, to};
    }
    case INTERVALS.CURRENT_YEAR.value: {
        const today = new Date();
        const from = startOfYear(today);
        const to = endOfYear(today);
        return {from, to};
    }
    case INTERVALS.LAST_MONTH.value: {
        const today = subMonths(new Date(), 1);
        const currentMonthStart = startOfMonth(today);
        const currentMonthEnd = endOfMonth(today);
        return {
            from: currentMonthStart,
            to: currentMonthEnd
        };
    }
    case INTERVALS.LAST_MONTH_TO_DATE.value: {
        const today = subMonths(new Date(), 1);
        const from = startOfMonth(today);
        return {
            from,
            to: new Date(),
        };
    }
    case INTERVALS.LAST_QUARTER.value: {
        const now = new Date();
        const from = startOfQuarter(subQuarters(now, 1)); // Start of the last quarter
        const to = endOfQuarter(subQuarters(now, 1));
        return {
            from, to
        };
    }
    case INTERVALS.LAST_QUARTER_TO_DATE.value: {
        const now = new Date();
        const from = startOfQuarter(subQuarters(now, 1)); // Start of the last quarter
        return {
            from,
            to: new Date()
        };
    }
    case INTERVALS.LAST_YEAR.value: {
        const now = new Date();
        const lastYear = subYears(now, 1);
        const from = startOfYear(lastYear);
        const to = endOfYear(lastYear);
        return  {from, to};
    }
    case INTERVALS.LAST_YEAR_TO_DATE.value: {
        const now = new Date();
        const lastYear = subYears(now, 1);
        const from = startOfYear(lastYear);
        return  {from, to: new Date()};
    }

    case INTERVALS.SINCE_60_DAYS_AGO.value: {
        const now = new Date();
        const from =  subDays(now, 30);
        return  {from, to: now};
    }
    case INTERVALS.SINCE_30_DAYS_AGO.value: {
        const now = new Date();
        const from =  subDays(now, 60);
        return  {from, to: now};
    }
    case INTERVALS.SINCE_90_DAYS_AGO.value: {
        const now = new Date();
        const from =  subDays(now, 90);
        return  {from, to: now};
    }
    case INTERVALS.SINCE_365_DAYS_AGO.value: {
        const now = new Date();
        const from =  subDays(now, 365);
        return  {from, to: now};
    }
    case INTERVALS.CUSTOM_DATE.value : {
        return  {
            from:dateFrom,
            to:dateTo
        };
    }
    }
}

export const INTERVALS = {
    CURRENT_MONTH: {
        value: "CURRENT_MONTH",
        label: "This Month",
        units: "month",
        amount: null,
        toActualDate: true,
        func: "currentX",
    },
    CUSTOM_DATE: {
        value: "CUSTOM_DATE",
        label: "Custom Date",
        units: "",
        amount: null,
        toActualDate: false,
    },
    CURRENT_QUARTER: {
        value: "CURRENT_QUARTER",
        label: "This Quarter",
        units: "quarter",
        amount: null,
        toActualDate: true,
        func: "currentX",
    },
    CURRENT_YEAR: {
        value: "CURRENT_YEAR",
        label: "This Year",
        units: "year",
        amount: null,
        toActualDate: true,
        func: "currentX",
    },
    LAST_MONTH: {
        value: "LAST_MONTH",
        label: "Last Month",
        units: "month",
        amount: null,
        toActualDate: false,
        func: "lastX",
    },
    LAST_MONTH_TO_DATE: {
        value: "LAST_MONTH_TO_DATE",
        label: "Last Month-to-date",
        units: "month",
        amount: null,
        toActualDate: true,
        func: "lastX",
    },
    LAST_QUARTER: {
        value: "LAST_QUARTER",
        label: "Last Quarter",
        units: "quarter",
        amount: null,
        toActualDate: false,
        func: "lastX",
    },
    LAST_QUARTER_TO_DATE: {
        value: "LAST_QUARTER_TO_DATE",
        label: "Last Quarter-to-date",
        units: "quarter",
        amount: null,
        toActualDate: true,
        func: "lastX",
    },
    LAST_YEAR: {
        value: "LAST_YEAR",
        label: "Last Year",
        units: "year",
        amount: null,
        toActualDate: false,
        func: "lastX",
    },
    LAST_YEAR_TO_DATE: {
        value: "LAST_YEAR_TO_DATE",
        label: "Last Year-to-date",
        units: "year",
        amount: null,
        toActualDate: true,
        func: "lastX",
    },
    SINCE_30_DAYS_AGO: {
        value: "SINCE_30_DAYS_AGO",
        label: "Since 30 Days Ago",
        units: "day",
        amount: 30,
        toActualDate: false,
        func: "chooseSinceXTimeAgo",
    },
    SINCE_60_DAYS_AGO: {
        value: "SINCE_60_DAYS_AGO",
        label: "Since 60 Days Ago",
        units: "day",
        amount: 60,
        toActualDate: false,
        func: "chooseSinceXTimeAgo",
    },
    SINCE_90_DAYS_AGO: {
        value: "SINCE_90_DAYS_AGO",
        label: "Since 90 Days Ago",
        units: "day",
        amount: 90,
        toActualDate: false,
        func: "chooseSinceXTimeAgo",
    },
    SINCE_365_DAYS_AGO: {
        value: "SINCE_365_DAYS_AGO",
        label: "Since 365 Days Ago",
        units: "day",
        amount: 365,
        toActualDate: false,
        func: "chooseSinceXTimeAgo",
    },
};
